
(function () {
  'use strict';

  var SECTION_ID = 'collection-search-data';
  var MIN_CHARS = 2;
  var MAX_RESULTS = 20;
  var DEBOUNCE_MS = 120;
  var CONCURRENCY = 3;
  var MAX_PAGES = 8;
  var CACHE_PREFIX = 'twolane:collection-index:v1:';
  var CACHE_MAX_CHARS = 1500000;
  var RETRY_AFTER_MS = 10000;

  function money(cents) {
    return window.TwoLaneCart && window.TwoLaneCart.formatMoney
      ? window.TwoLaneCart.formatMoney(cents)
      : '$' + (Number(cents) / 100).toFixed(2);
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  var NON_WORD = (function () {
    try { return new RegExp('[^\\p{L}\\p{N}]+', 'gu'); }
    catch (e) { return /[^a-z0-9\u00c0-\u024f]+/g; }
  })();
  var MARKS = /[\u0300-\u036f]/g;
  var APOSTROPHES = /['\u2019]/g;

  function normalize(value) {
    var s = String(value == null ? '' : value).toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(MARKS, '');
    return s.replace(APOSTROPHES, '').replace(NON_WORD, ' ').trim();
  }

  function tokenize(query) {
    var seen = {};
    return normalize(query).split(' ').filter(function (token) {
      if (!token || seen[token]) return false;
      seen[token] = true;
      return true;
    });
  }

  function prepare(item) {
    var sku = normalize(item.s);
    return {
      item: item,
      title: ' ' + normalize(item.t),
      other: ' ' + [normalize(item.v), normalize(item.y), sku, sku.replace(/ /g, '')].join(' ')
    };
  }

  function score(entry, tokens) {
    var total = 0;
    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];
      if (entry.title.indexOf(' ' + token) !== -1) total += 3;
      else if (entry.title.indexOf(token) !== -1) total += 2;
      else if (entry.other.indexOf(token) !== -1) total += 1;
      else return 0;
    }
    return total;
  }

  function rank(entries, tokens) {
    var hits = [];
    for (var i = 0; i < entries.length; i++) {
      var s = score(entries[i], tokens);
      if (s) hits.push({ entry: entries[i], score: s, order: i });
    }
    hits.sort(function (a, b) {
      return (b.score - a.score) ||
        ((b.entry.item.a ? 1 : 0) - (a.entry.item.a ? 1 : 0)) ||
        (a.order - b.order);
    });
    return hits;
  }

  var instances = 0;

  function attach(form) {
    if (form.hasAttribute('data-collection-search-ready')) return;
    var input = form.querySelector('input[type="search"]');
    var collectionUrl = form.getAttribute('data-collection-url') || '';
    var handle = form.getAttribute('data-collection-handle') || '';
    if (!input || !collectionUrl || !handle) return;
    form.setAttribute('data-collection-search-ready', '');

    var productCount = form.getAttribute('data-collection-count') || '';
    var collectionTitle = form.getAttribute('data-collection-title') || '';
    var searchUrl = form.getAttribute('action') || '/search';
    var uid = 'collection-search-' + (++instances);

    var panel = document.createElement('div');
    panel.className = 'collection-search__panel';
    panel.hidden = true;

    var statusLine = document.createElement('p');
    statusLine.className = 'collection-search__status';
    statusLine.setAttribute('aria-hidden', 'true');

    var list = document.createElement('div');
    list.className = 'collection-search__list';
    list.id = uid + '-list';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', input.getAttribute('placeholder') || collectionTitle);

    panel.appendChild(statusLine);
    panel.appendChild(list);
    form.appendChild(panel);

    var live = document.createElement('p');
    live.className = 'visually-hidden';
    live.setAttribute('role', 'status');
    form.appendChild(live);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', list.id);
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('autocomplete', 'off');

    var pageEntries = [];   // prepared entries, one array per page
    var entries = [];       // all pages so far, in collection order
    var indexPages = 0;     // pages this index will hold: min(collection, MAX_PAGES)
    var havePage1 = false;
    var deepWanted = false;
    var complete = false;   // every page this index will hold is in hand
    var loading = false;
    var failedAt = 0;
    var activeIndex = -1;

    function setPage(page, items) {
      pageEntries[page - 1] = (Array.isArray(items) ? items : []).map(prepare);
      entries = [];
      for (var i = 0; i < pageEntries.length; i++) {
        if (pageEntries[i]) entries = entries.concat(pageEntries[i]);
      }
    }

    function cacheKey() {
      var shopify = window.Shopify || {};
      return CACHE_PREFIX + [
        handle,
        productCount,
        document.documentElement.lang || '',
        shopify.country || '',
        (shopify.currency && shopify.currency.active) || ''
      ].join(':');
    }

    function readCache() {
      try {
        var raw = window.sessionStorage.getItem(cacheKey());
        if (!raw) return null;
        var data = JSON.parse(raw);
        return data && Array.isArray(data.items) ? data.items : null;
      } catch (e) {
        return null;
      }
    }

    function writeCache(items) {
      var payload;
      try { payload = JSON.stringify({ items: items }); } catch (e) { return; }
      if (payload.length > CACHE_MAX_CHARS) return;
      var key = cacheKey();
      try {
        window.sessionStorage.setItem(key, payload);
      } catch (e) {
        try {
          for (var i = window.sessionStorage.length - 1; i >= 0; i--) {
            var k = window.sessionStorage.key(i);
            if (k && k.indexOf(CACHE_PREFIX) === 0 && k !== key) window.sessionStorage.removeItem(k);
          }
          window.sessionStorage.setItem(key, payload);
        } catch (err) { /* still no room: carry on uncached */ }
      }
    }

    function pageUrl(page) {
      var base = collectionUrl.split('#')[0];
      return base + (base.indexOf('?') === -1 ? '?' : '&') +
        'section_id=' + SECTION_ID + '&page=' + page;
    }

    function fetchPage(page) {
      return fetch(pageUrl(page), { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('collection index HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var node = doc.querySelector('script[data-collection-index]');
          if (!node) throw new Error('collection index missing');
          var data = JSON.parse(node.textContent);
          if (!data || !Array.isArray(data.items)) throw new Error('collection index malformed');
          return data;
        });
    }

    function load(deep) {
      if (deep) deepWanted = true;
      if (complete || loading) return;
      if (failedAt && Date.now() - failedAt < RETRY_AFTER_MS) return;
      if (havePage1 && !deepWanted) return;

      if (!havePage1) {
        var cached = readCache();
        if (cached) {
          setPage(1, cached);
          havePage1 = true;
          indexPages = 1;
          complete = true;
          return;
        }
      }

      loading = true;
      failedAt = 0;
      var partial = false;
      var wentDeep = false;

      (havePage1 ? Promise.resolve() : fetchPage(1).then(function (first) {
        setPage(1, first.items);
        havePage1 = true;
        indexPages = Math.min(Math.max(Number(first.pages) || 1, 1), MAX_PAGES);
      }))
        .then(function () {
          if (indexPages < 2 || !deepWanted) return null;
          wentDeep = true;
          refresh(false);

          var queue = [];
          for (var p = 2; p <= indexPages; p++) queue.push(p);

          return new Promise(function (resolve) {
            var running = 0;
            function next() {
              if (!queue.length) {
                if (running === 0) resolve();
                return;
              }
              var page = queue.shift();
              running++;
              fetchPage(page)
                .then(function (data) { setPage(page, data.items); },
                      function () { partial = true; })
                .then(function () {
                  running--;
                  refresh(false);
                  next();
                });
            }
            for (var i = 0; i < CONCURRENCY; i++) next();
          });
        })
        .then(function () {
          loading = false;
          if (wentDeep || indexPages === 1) {
            complete = true;
            if (!partial) writeCache(entries.map(function (entry) { return entry.item; }));
          }
          refresh(true);
          if (!complete && deepWanted) load();
        })
        .catch(function () {
          loading = false;
          failedAt = Date.now();
          if (!entries.length) hide();
        });
    }

    function options() {
      return Array.prototype.slice.call(list.querySelectorAll('[role="option"]'));
    }

    function setActive(i) {
      var opts = options();
      if (!opts.length) return;
      if (i < 0) i = opts.length - 1;
      if (i >= opts.length) i = 0;
      activeIndex = i;
      opts.forEach(function (opt, n) {
        opt.setAttribute('aria-selected', n === activeIndex ? 'true' : 'false');
        opt.classList.toggle('is-active', n === activeIndex);
      });
      input.setAttribute('aria-activedescendant', opts[activeIndex].id);
      opts[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    function hide() {
      panel.hidden = true;
      activeIndex = -1;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function statusText(shown, found) {
      var vars = { COUNT: shown, SHOWN: shown, TOTAL: found, COLLECTION: collectionTitle };
      if (loading) return window.t('collection_search_loading', 'Loading products\u2026');
      if (shown === 0) return window.t('collection_search_none', 'No matches in __COLLECTION__', vars);
      if (found > shown) {
        return window.t('collection_search_showing',
          'Showing __SHOWN__ of __TOTAL__ matches in __COLLECTION__', vars);
      }
      if (shown === 1) return window.t('collection_search_matches_one', '1 match in __COLLECTION__', vars);
      return window.t('collection_search_matches_other', '__COUNT__ matches in __COLLECTION__', vars);
    }

    function optionHtml(item, i) {
      var media = item.i
        ? '<img class="collection-search__img" src="' + esc(item.i) + '" alt="" width="46" height="46" loading="lazy">'
        : '<span class="collection-search__img" aria-hidden="true"></span>';
      var soldOut = item.a ? '' :
        ' <span class="collection-search__soldout">' + esc(window.t('sold_out', 'Sold out')) + '</span>';

      return '<a class="collection-search__item" role="option" aria-selected="false" tabindex="-1"' +
               ' id="' + uid + '-opt-' + i + '" href="' + esc(/^\/(?!\/)/.test(String(item.u || '')) ? item.u : '#') + '">' +
               media +
               '<span class="collection-search__text">' +
                 '<span class="collection-search__title">' + esc(item.t) + '</span>' +
                 (item.v ? '<span class="collection-search__vendor">' + esc(item.v) + '</span>' : '') +
                 '<span class="collection-search__price">' + esc(money(item.p)) + soldOut + '</span>' +
               '</span>' +
             '</a>';
    }

    function render(query, hits, opts) {
      var activeHref = null;
      if (opts.keepActive && activeIndex > -1) {
        var current = options()[activeIndex];
        if (current) activeHref = current.getAttribute('href');
      }

      var allUrl = searchUrl + (searchUrl.indexOf('?') === -1 ? '?' : '&') +
        'q=' + encodeURIComponent(query) + '&type=product';

      list.innerHTML = hits.slice(0, MAX_RESULTS).map(function (hit, i) {
        return optionHtml(hit.entry.item, i);
      }).join('') +
        '<a class="collection-search__all" role="option" aria-selected="false" tabindex="-1"' +
          ' id="' + uid + '-all" href="' + esc(allUrl) + '">' +
          esc(window.t('collection_search_all', 'Search all products for \u201c__TERMS__\u201d', { TERMS: query })) +
        '</a>';

      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
      if (activeHref) {
        var fresh = options();
        for (var j = 0; j < fresh.length; j++) {
          if (fresh[j].getAttribute('href') === activeHref) { setActive(j); break; }
        }
      }

      var text = statusText(Math.min(hits.length, MAX_RESULTS), hits.length);
      statusLine.textContent = text;
      if (opts.announce && live.textContent !== text) live.textContent = text;

      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function update(opts) {
      opts = opts || {};
      var query = input.value.trim();
      var tokens = query.length >= MIN_CHARS ? tokenize(query) : [];
      if (!tokens.length || (!entries.length && !loading)) { hide(); return; }
      render(query, rank(entries, tokens), opts);
    }

    function refresh(announce) {
      if (document.activeElement !== input && panel.hidden) return;
      update({ keepActive: true, announce: announce });
    }

    var search = debounce(function () { update({ announce: true }); }, DEBOUNCE_MS);

    function loadForInput() {
      load(input.value.trim().length >= MIN_CHARS);
    }

    input.addEventListener('focus', function () {
      loadForInput();
      if (input.value.trim().length >= MIN_CHARS) update({});
    });

    input.addEventListener('input', function () {
      loadForInput();
      if (input.value.trim().length < MIN_CHARS) { hide(); return; }
      search();
    });

    input.addEventListener('keydown', function (e) {
      loadForInput();
      if (e.isComposing) return;

      if (e.key === 'Escape') {
        if (!panel.hidden) { e.preventDefault(); hide(); }
        return;
      }

      if (panel.hidden) {
        if (e.key === 'ArrowDown' && input.value.trim().length >= MIN_CHARS) {
          e.preventDefault();
          update({ announce: true });
        }
        return;
      }

      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIndex + 1); return; }
      if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIndex - 1); return; }

      if (e.key === 'Enter' && activeIndex > -1) {
        var opt = options()[activeIndex];
        if (opt) {
          e.preventDefault();
          window.location.href = opt.getAttribute('href');
        }
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) hide();
    });

    document.addEventListener('focusin', function (e) {
      if (!form.contains(e.target)) hide();
    });

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) hide();
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-collection-search]'), attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
